<template>
  <div id="mnemonicWord">
    <mt-header fixed title>
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="content">
      <div class="swiper">
        <p class="wx_fontSize4" style="font-weight: bold;">{{$t('请抄写 HMC Wallet Pro 助记词')}}</p>
        <p class="wx_fontSize2">{{$t('HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。')}}</p>
        <p class="wx_fontSize2">{{$t('请勿截图！如果有人获取你的助记词将直接获取你的资产！')}}</p>
      </div>
      <ul class="table clearfix">
        <li v-for="(item,index) in list" class="wx_fontSize3" :key="index">
          <mt-badge size="small">{{index+1}}</mt-badge>
          {{item}}
        </li>
      </ul>
      <div class="footer wx_fontSize3" @click="backupTip()">{{$t('我已安全保存')}}</div>
    </div>
  </div>
</template>

<script>
import { Indicator } from "mint-ui";
import { validateEmpty } from "@/utils/validate";
import { createUniqueString } from "@/utils/index";
import { generateAddress } from "@/utils/hdwallet";
import { httpList, httpCreate, httpInit } from "@/api/hdwallet";
export default {
  data() {
    return {
      list: [],
      ethAddress: "",
      btcAddress: ""
    };
  },
  methods: {
    backupTip() {
      if(validateEmpty(this.$store.state.hdtoken)){
        this.$router.push("/safety");
        //this.createHdWallet();
      }else{
        this.$router.back()
      }

    },
    createHdWallet: function() {
      return httpCreate({ primary_key: createUniqueString() })
        .then(res => {
          this.$store.dispatch("setHdToken", res.data.hd_token);
          this.initHdWallet();
        })
        .catch(() => {});
    },
    initHdWallet: function() {
      return httpInit({ BTC: this.btcAddress, ETH: this.ethAddress })
        .then(res => {
          this.$router.push("/safety");
          //this.getLocalData();
        })
        .catch(() => {});
    },
    generateHdAddress: function() {
      if (validateEmpty(window.LS.get("mnemonic"))) {
        var result = generateAddress();
        this.ethAddress = result.ethAddress;
        this.btcAddress = result.btcAddress;
        this.list = result.mnemonic.split(" ");
      } else {
        this.list = window.LS.get("mnemonic").split(" ");
      }
    }
  },
  mounted: function() {},
  activated() {
    this.generateHdAddress();
  }
};
</script>

<style scoped>
#mnemonicWord {
  width: 100%;
  min-height: 100%;
  background-image: url('../../assets/img/index/bg_bendi_home.png');
}
.mint-header {
  background: transparent;
}
.backG {
  width: 100%;
  height: 100%;
}
.mark {
  width: 86%;
  margin-left: 7%;
  /* padding-top: 50px; */
  height: 36%;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
}
.swiper {
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  padding-top: 40px;
  box-sizing: border-box;
}
.swiper p {
  margin: 25px 5px;
}
.table {
  padding: 0px 15px 20px 15px;
  margin-left: 3px;
}
.table li {
  width: calc((100% / 3) - 3px);
  height: 50px;
  float: left;
  text-align: center;
  color: #fff;
  border: 0.5px solid #fff;
  line-height: 50px;
  position: relative;
}
.footer {
  width: calc(100% - 30px);
  height: 50px;
  background: #fff;
  line-height: 50px;
  text-align: center;
  color: #1296db;
  border-radius: 4px;
  position: relative;
  margin: 20px 0 20px 15px;
}
.mint-badge.is-primary {
  background: transparent;
  position: absolute;
  top: -10px;
  left: 5px;
}
</style>